export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_07.7678656d.jpg";